import type { LeaderboardRow } from '../types';

// Matches the canonical "active" set used by /team and the backend
// progress.js ACTIVE_STATUS_LIST. Duplicated (not imported from
// /modules/team) per the module-isolation rule in CLAUDE.md.
const ACTIVE_STATUSES = new Set(['healthy', 'test', 'redemption_test']);

export function countActive(rows: LeaderboardRow[]): number {
  return rows.filter((r) => ACTIVE_STATUSES.has(r.account_status ?? 'healthy'))
    .length;
}
